import { defineMessages } from '@cookbook/solid-intl'

// Split out of `tos-page.messages.en.js` (which also holds the full ~130KB of
// Terms of Service body copy) so the router's document-title/meta-description
// wiring in `tos-page-routing.js` doesn't have to eagerly pull in that entire
// legal text into the boot-critical chunk just for these two small strings.
// `web-routing.js` re-exports every routing file, and `router.jsx` imports it
// statically (it needs the full route table upfront), so whatever a routing
// file imports at module scope ends up in every route's shared boot bundle —
// including marketing pages that never render this page.
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Learn about Lodgr’s terms of service. Understand your rights and responsibilities when using the platform.',
        id: 'TOSPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Terms of Service | Lodgr',
        id: 'TOSPage.titleMessage',
    }),
}
